import getBrowserFingerprint from 'get-browser-fingerprint';

//import {publicIpv4} from 'public-ip';

import { NO_DATA_MESSAGE } from '../../utils/HttpHelper';
import ToIntIfInt from '../../utils/ToIntIfInt';

// BFF reads sub and sid from the session cookie and calls security-api itself.
// Deployed UIs sit on a static host with no BFF, so they need the absolute origin. Local runs
// leave VITE_BFF_BASE_URL unset and stay relative, because yarp CORS rejects localhost and the
// vite proxy already forwards /bff.
const postSecurityInfo = async (payload) => {
  const bffBaseUrl = import.meta.env.VITE_BFF_BASE_URL == 'bff' ? '' : import.meta.env.VITE_BFF_BASE_URL ?? '';
  const response = await fetch(`${bffBaseUrl}/bff/swimssecurityinfo`, {
    method: 'POST',
    credentials: 'include',
    redirect: 'manual',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    throw new Error(NO_DATA_MESSAGE);
  }

  return response.json();
};

const GetSecurityInfoForToken = async (taxonomies, scope, token, bustCache, state, setState) => {
  if ((state?.retries || 0) < 3 && state.isArrayLoading !== true) {
    let newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    // const ip = await publicIpv4();
    
    // function ip2int(ip) {
    //   return ip.split('.').reduce(function(ipInt, octet) { return (ipInt<<8) + parseInt(octet, 10)}, 0) >>> 0;
    // }

    // const host = ip2int(ip);

    // const hostId = window.btoa(host.toString());

    const fingerprint = await getBrowserFingerprint({ hardwareOnly: false, debug: false })
      .catch((e) => { 
        console.error('Error getting fingerprint: ', e);
      });

      const postPayload = { 
      toxonomies: taxonomies,
      scope,
      uIProjectName: import.meta.env.VITE_PROJECT_NAME,
      bustCache: bustCache ?? false,
      appName: import.meta.env.VITE_PROJECT_NAME === 'times-microsite-ui' ? 'Data' : 'OMR',
      deviceId: fingerprint?.toString(),
      hostId: 'swims-web-client',
    };
    postSecurityInfo(postPayload)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            userInfo: {
              ...objData,
              encryptedRequestId: objData.requestId ? ToIntIfInt(objData.requestId) * 13 : '',
              deviceId: fingerprint,
              isLoggedIn: objData?.firstName !== 'Anonymous',
              isUnregistered: objData?.firstName !== 'Unregistered'
            },
            message: '',
            retries: 0
          };
          setState(newState);
          if (objData?.requestId === '') {
            console.error('No Session Id returned from /bff/swimssecurityinfo');
          }
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        const retries = (newState.retries || 0) + 1;
        newState = {
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          userInfo: {},
          message: message,
          retries
        };
        setState(newState);
      });

    // const postPayload = {
    //   access_token: token,
    //   toxonomies: taxonomies,
    //   scope,
    //   uIProjectName: import.meta.env.VITE_PROJECT_NAME,
    //   bustCache: bustCache ?? false,
    //   appName: import.meta.env.VITE_PROJECT_NAME === 'times-microsite-ui' ? 'Data' : 'OMR',
    //   deviceId: fingerprint,
    //   hostId: 'swims-web-client',
    // };
    // const url = '/Auth/GetSecurityInfoForToken';
    // SecurityHttpHelper(url, 'POST', postPayload)
    //   .then((objData) => {
    //     if (!objData) {
    //       throw new Error(NO_DATA_MESSAGE);
    //     } else {
    //       newState = {
    //         ...newState,
    //         isObjLoading: false,
    //         isObjLoaded: true,
    //         userInfo: {
    //           ...objData,
    //           encryptedRequestId: objData.requestId ? ToIntIfInt(objData.requestId) * 13 : '',
    //           deviceId: fingerprint,
    //           isLoggedIn: objData?.firstName !== 'Anonymous',
    //           isUnregistered: objData?.firstName !== 'Unregistered'
    //         },
    //         message: '',
    //         retries: 0
    //       };
    //       setState(newState);
    //       if (objData?.requestId === '') {
    //         console.error('No Session Id returned from GetSecurityInfoForToken');
    //       }
    //     }
    //   })
    //   .catch((e) => {
    //     const message = e && e.message ? e.message : NO_DATA_MESSAGE;
    //     const retries = (newState.retries || 0) + 1;
    //     newState = {
    //       ...newState,
    //       isObjLoading: false,
    //       isObjLoaded: false,
    //       userInfo: {},
    //       message: message,
    //       retries
    //     };
    //     setState(newState);
    //   });
  }
};

export default GetSecurityInfoForToken;